var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"effects"},_vm._l((_vm.effects),function(e){return _c('div',{key:e.id,staticClass:"timer"},[_c('timer',{attrs:{"duration":e.duration}}),_c('div',{class:'pill ' + e})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }